(ns app.front.view.group.admin.letter.bond-snippet-editor
  (:require [app.domain.letter.model :as letter-model]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.templates.document-editor :as document-editor])
  (:require-macros [core.util.util :as util]))

(defn bond-snippets-editor [{:keys [visible-fragment-types
                                    get-external-edit-state-key
                                    tr
                                    inherited?
                                    images
                                    group-id
                                    document-id]}]

  (when (contains? visible-fragment-types :letter-fragment/bond-snippet)
    [document-editor/editor
     (-> (util/mmap {:title              [:h4 (tr [:letter/bond-snippet])]
                     :read-only?         inherited?
                     :placeholders       letter-model/bond-snippet-variables
                     :small?             true
                     :html-fragment-type :letter-fragment/bond-snippet}
                    tr images group-id document-id)
         (text-editor/with-external-edit-state (get-external-edit-state-key :letter-fragment/bond-snippet)))]))
